<template>
  <div>
    <ConfigBox
      :formIsInvalid="$v.default_bank_account.$invalid"
      :callback="
        password =>
          saveConfig(
            default_bank_account,
            'UPDATE_RECIPIENT_DEFAULT_BANK_ACCOUNT',
            password
          )
      "
      :title="$t('recipients.details.box.recipient_settings')"
      :hasPassword="true"
      :mfaNeeded="!hasUserTwoFactorAuthentication"
    >
      <template v-slot:content>
        <BankAccount
          :default_bank_account="default_bank_account"
          :vuelidate="$v"
        />
      </template>
    </ConfigBox>

    <ConfigBox
      :formIsInvalid="$v.automatic_anticipation_settings.$invalid"
      :callback="
        password =>
          saveConfig(
            automatic_anticipation_settings,
            'UPDATE_RECIPIENT_ANTICIPATION_SETTINGS',
            password
          )
      "
      :title="$t('recipients.details.box.recipient_prepayment_settings')"
      :hasPassword="true"
      :mfaNeeded="!hasUserTwoFactorAuthentication"
    >
      <template v-slot:content>
        <PrepaymentSettings
          :automatic_anticipation_settings="automatic_anticipation_settings"
          :vuelidate="$v"
        />
      </template>
    </ConfigBox>

    <ConfigBox
      :formIsInvalid="transferSettingsIsInvalid"
      :callback="saveEditTransferSettings"
      :title="$t('recipients.details.box.transfer_settings')"
      :hasPassword="true"
      :mfaNeeded="!hasUserTwoFactorAuthentication"
      @cancelEdit="cancelEditTransferSettings"
    >
      <template v-slot:content>
        <TransferSettings
          :transferSettingsIsInvalid.sync="transferSettingsIsInvalid"
          :transfer_settings="transferSettingsEditData"
        />
      </template>
    </ConfigBox>
  </div>
</template>

<script>
import ConfigBox from '@/components/project/molecules/ConfigBox.vue'
import BankAccount from '../../Form/BankAccount.vue'
import PrepaymentSettings from '../../Form/PrepaymentSettings.vue'
import TransferSettings from '../../Form/TransferSettings.vue'
import { mapGetters } from 'vuex'

import {
  personalUser,
  defaultBankAccountValidations,
  prepaymentValidations
} from '../../Form/validations'
import { isTransferIntervalTypeDaily } from '@/enums/transfer-settings.enum'

export default {
  components: {
    ConfigBox,
    BankAccount,
    PrepaymentSettings,
    TransferSettings
  },
  data () {
    return {
      transferSettingsEditData: {},
      transferSettingsIsInvalid: false
    }
  },
  props: {
    default_bank_account: {
      type: Object,
      required: true
    },
    automatic_anticipation_settings: {
      type: Object,
      required: true
    },
    transfer_settings: {
      type: Object,
      required: true
    }
  },
  validations () {
    return {
      recipient: personalUser,
      default_bank_account: defaultBankAccountValidations,
      automatic_anticipation_settings: prepaymentValidations
    }
  },
  computed: {
    ...mapGetters(['hasUserTwoFactorAuthentication']),
    requestParams () {
      return {
        merchantId: this.$route.params.merchant_id,
        accountId: this.$route.params.account_id,
        recipientId: this.$route.params.id
      }
    }
  },
  methods: {
    saveConfig (obj, action, password) {
      const body = {
        ...this.getRequestBody(obj),
        password
      }

      const params = {
        ...this.requestParams,
        body
      }

      return this.$store.dispatch(action, params)
    },
    getRequestBody (body) {
      const obj = { ...body }

      if ('branch_check_digit' in obj && obj.branch_check_digit === '') {
        delete obj.branch_check_digit
      }

      return obj
    },
    resetTransferSettingsEditData () {
      this.transferSettingsEditData = { ...this.transfer_settings }
    },
    cancelEditTransferSettings () {
      this.resetTransferSettingsEditData()
    },
    saveEditTransferSettings (password) {
      if (
        isTransferIntervalTypeDaily(this.transfer_settings.transfer_interval)
      ) {
        this.transfer_settings.transfer_day = 0
      }

      return this.saveConfig(
        this.transferSettingsEditData,
        'UPDATE_RECIPIENT_TRANSFER_SETTINGS',
        password
      )
    }
  },
  mounted () {
    this.resetTransferSettingsEditData()
  }
}
</script>
